import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { RsvpStore } from './rsvp.store';
import { ReservationStore } from './reservation-store';
import { EventHttpService } from './event.http.service';
import { catchError, filter, map, take, tap } from 'rxjs/operators';
import { Response } from '@angular/http';
import { FlashMessagesService } from 'app/shared/flash-messages/service/flash.messages.service';
import { EventHasItemsByVendor } from '../models/event-has-items-by-vendor';

@Injectable()
export class EventHasItemsResolver implements Resolve<any> {

  constructor(private eventHttpService: EventHttpService,
    private reservationStore: ReservationStore,
    private rsvpStore: RsvpStore,
    private flashMessagesService: FlashMessagesService,
    private translateService: TranslateService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<void> {

    const eventId = route.params[ 'id' ];
    if (!eventId) {
      throw new Error(this.translateService.instant('MESSAGES.ERROR.COULD_NOT_CHECK_EVENT_HAS_ITEMS'));
    }

    const eventPartyId = route.params[ 'eventPartyId' ];
    let serviceCall: Observable<EventHasItemsByVendor | Response>;
    if (!!eventPartyId) {
      serviceCall = this.eventHttpService.fetchHasItemsByParty(eventId, eventPartyId);
    } else {
      serviceCall = this.eventHttpService.fetchHasItems(eventId);
    }

    return serviceCall.pipe(
      take(1),
      catchError((error: any) => {
        this.flashMessagesService.error(
          'MESSAGES.ERROR.COULD_NOT_CHECK_EVENT_HAS_ITEMS',
          `Error retrieving items: ${ error }`
        );
        return Observable.throw(error);
      }),
      filter((response: EventHasItemsByVendor | Response) => response instanceof EventHasItemsByVendor),
      tap((eventHasItemsByVendor: EventHasItemsByVendor) => {
        this.reservationStore.loadEventHasReservationsCache(eventHasItemsByVendor.hasReservationsByVendor);
        this.rsvpStore.loadEventHasRsvpsCache(eventHasItemsByVendor.hasRsvpsByVendor);
      }),
      map(() => {
        return;
      })
    );
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/service/event-has-items.resolver.ts